import {
  IconArrowBackUpDouble,
  IconArrowForwardUpDouble,
  IconBan,
  IconMail,
} from '@rossum/ui/icons/tabler';
import { SvgIcon } from '@rossum/ui/material';

export const emailSummaryIcon: Record<
  | ('rejection' | 'forwarded' | 'reply' | 'default')
  | (string & Record<never, never>),
  JSX.Element
> = {
  rejection: (
    <SvgIcon fontSize="medium">
      <IconBan />
    </SvgIcon>
  ),
  automatic_rejection: (
    <SvgIcon fontSize="medium">
      <IconBan />
    </SvgIcon>
  ),
  forwarded: (
    <SvgIcon fontSize="medium">
      <IconArrowForwardUpDouble />
    </SvgIcon>
  ),
  automatic_status_changed_info: (
    <SvgIcon fontSize="medium">
      <IconArrowBackUpDouble />
    </SvgIcon>
  ),
  reply: (
    <SvgIcon fontSize="medium">
      <IconArrowBackUpDouble />
    </SvgIcon>
  ),
  default: (
    <SvgIcon fontSize="medium">
      <IconMail />
    </SvgIcon>
  ),
};
